import { render, staticRenderFns } from "./AllLeads.vue?vue&type=template&id=c3c65f48&scoped=true&"
import script from "./AllLeads.vue?vue&type=script&lang=js&"
export * from "./AllLeads.vue?vue&type=script&lang=js&"
import style0 from "./AllLeads.vue?vue&type=style&index=0&id=c3c65f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c65f48",
  null
  
)

export default component.exports